module.exports = __webpack_public_path__ + "static/img/banner2信用创造价值.f3d7cbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2信用创造价值.jpg
// module id = Xh36
// module chunks = 1